import React, { Suspense, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { lazy } from '@loadable/component';
import useIsLogged from '@fingo/lib/hooks/useIsLogged';
import FingoCircularProgressLoader from '@fingo/lib/components/loader/FingoCircularProgressLoader';

const AuthenticatedRoute = lazy(() => import(
  /* webpackChunkName: "authenticated-route" */ './AuthenticatedRoute'
));

function PrivateRoute({ component, ...rest }) {
  const isLogged = useIsLogged();
  const history = useHistory();

  useEffect(() => {
    if (!isLogged) {
      history.replace({
        pathname: '/',
        search: `?next=${history.location.pathname}${history.location.search}`,
      });
    }
  }, [isLogged, history]);

  if (!isLogged) return null;

  return (
    <Suspense fallback={<FingoCircularProgressLoader />}>
      <AuthenticatedRoute component={component} {...rest} />
    </Suspense>
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.elementType,
  ]).isRequired,
};

export default PrivateRoute;
